import "./LandingIntegrations.css";

const INTEGRATIONS = [
  {
    id: "1",
    img: "centric.png",
    title: "Centric",
    description: "Koppelt met applicaties als Suite4sociaal domein en suite4regie",
  },
  {
    id: "2",
    img: "pinkroccade.png",
    title: "PinkRoccade",
    description: "Integratie mogelijk met Isam en Csam",
  },
  {
    id: "3",
    img: "zorgned.png",
    title: "ZorgNed",
    description: "Integratie mogelijk met ZorgNed",
  },
  {
    id: "4",
    img: "mercell.png",
    title: "Mercell",
    description: "Work faster and smarter by integrating directly within the app.",
  },
  {
    id: "5",
    img: "ISPNext.png",
    title: "ISPNext",
    description: "Work faster and smarter by integrating directly within the app.",
  },
  {
    id: "6",
    img: "dropbox.png",
    title: "Uw Backoffice applicatie",
    description: "Work faster and smarter by integrating directly within the app.",
  },
];

function LandingIntegrations() {
  return (
    <section className="landing-integrations">
      <div className="landing-integrations__head">
        <span className="landing-integrations__eyebrow">Integraties</span>
        <h2 className="landing-integrations__title">Integreer ContinuMee in uw applicatielandschap</h2>
        <p className="landing-integrations__subtitle">
          ContinuMee kan als onderzoeksapplicatie geïntegreerd worden in het ecosysteem binnen uw organisatie voor een geautomatiseerd proces.
          ContinuMee is te koppelen met elke backoffice-applicatie.
        </p>
      </div>

      <div className="landing-integrations__grid">
        {INTEGRATIONS.map((integration) => (
          <div key={integration.id} className="landing-integrations__card">
            <div className="landing-integrations__logo">
              <img src={`/${integration.img}`} alt={integration.title} />
            </div>
            <div className="landing-integrations__card-body">
              <div className="landing-integrations__card-title">{integration.title}</div>
              <div className="landing-integrations__card-subtitle">{integration.description}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default LandingIntegrations;
